import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';


import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import { addConcept, editConcept, getConcept, listConceptLinks, getConceptModel } from "../utils/utilsConceptModel";

import D3Graphviz from "../components/D3Graphviz";
import ViewConcept from "../components/ViewConcept";
import ViewConceptModel from "../components/ViewConceptModel";
import ViewMetadata from "../components/ViewMetadata";


import SuperConceptRow from "../components/SuperConceptRow"

import ListConcepts from "../components/ListConcepts"

import Revision from "../components/Revision"
import ListRevisions from "../components/ListRevisions"

import Rendition from '../components/Rendition';


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Concept extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.addSuperConcept = this.addSuperConcept.bind(this);
        this.removeSuperConcept = this.removeSuperConcept.bind(this);
        this.updateSuperConcept = this.updateSuperConcept.bind(this);   


        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadConceptModel(id){

        let StateChange = {};
        StateChange.ConceptModel = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.ConceptModel = data;
            
            // Only set FormData for new mode - just default Concept values
            if (this.state.mode === 'new'){
                StateChange.FormData = {
                    status: 'in use'
                };
            }

            StateChange.renderState = "loaded";

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (data.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Concepts to this Concept Model";
                    break;
                }
            }

            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.ConceptModel = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getConceptModel(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;
        
    };

    loadConcept(id){

        let StateChange = {};
        StateChange.Concept = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Concept = data;
            StateChange.FormData = data;

            StateChange.renderState = "loaded";

            if (data.ConceptModel){
                StateChange.ConceptModel = data.ConceptModel;
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsConceptModel(data.ConceptModel._id);
                }
            }

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (data.ConceptModel && data.ConceptModel.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   




            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot edit this Concept";
                    break;
                }
            }

            this.setState(StateChange);

            // Fetch DOT from server
            this.fetchViz(id);

            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Concept = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        const onLoadLinks = function(data){
            this.setState({ConceptLinks: data});
        }.bind(this);

        const onErrorLinks = function(e){
            console.log(e);
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getConcept(this.dsd, id, onLoad, onFail);
//            listConceptLinks(this.dsd, {idConcept:id}, onLoadLinks, onErrorLinks);
        }

        this.setState(StateChange);

        return;
        
    };

    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getConcept(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };

    setup(){

        let StateChange = {

            mode: "view",

            idConcept: null,
            idConceptModel: null,

            ConceptModel: null,
            Concept: null,
            ConceptLinks: null,

            isUpdated: false,

            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {
                status:'in use'
            },

            OfferEdit:false,

            Controls: {
            },

            countRevisions: null,

            dot:null

        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idConcept = getParam('id', this.props);
        StateChange.idConceptModel = getParam('idConceptModel', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idConceptModel){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Concept Model not specified when adding a Concept"
                }
                break;
            default:
                if (StateChange.idConceptModel){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Concept Model should not be specified for an existing Concept"
                }
                if (!StateChange.idConcept){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Concept not specified"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idConceptModel){
                this.FallBackNavigation = `/conceptmodel/${StateChange.idConceptModel}`;
            }        
        }

        if (StateChange.idConceptModel){
            this.loadConceptModel(StateChange.idConceptModel);
        }
        if (StateChange.idConcept){
            this.loadConcept(StateChange.idConcept);
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/concept/${this.state.idConcept}`);
                        break;
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;
            case 'btnSave':
            default:

                this.setState({
                    renderState: "updating"
                })

                const onAdd = function(idConcept){
                    this.props.navigation(`/concept/${idConcept}`);
                    return;
                }.bind(this);

                const onUpdate = function(){
                    this.props.navigation(`/concept/${this.state.idConcept}`);
                    return;
                }.bind(this);

                const onError = function(e){
                    let StateChange = {};
                    StateChange.renderState = "error";
                    
                    StateChange.errorMessage = e.message;
                    if (e.response){
                        if (e.response.data){
                            if (e.response.data.message){
                                StateChange.errorMessage = e.response.data.message;
                            }
                        }
                    }
                    
                    this.setState(StateChange);
                }.bind(this);
        
                switch (this.state.mode){
                    case 'new':
                        addConcept(this.dsd, this.state.idConceptModel, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editConcept(this.dsd, this.state.idConcept, this.state.FormData, onUpdate, onError);
                        this.refRevision.current.update();
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    addSuperConcept(){
       let FormData = {...this.state.FormData};
       FormData.SuperConcepts = [...(FormData.SuperConcepts || []), {}];
  
       this.setState({"FormData": FormData});
    }

    removeSuperConcept(seq){

       let FormData = {...this.state.FormData};
       FormData.SuperConcepts = [...(FormData.SuperConcepts || [])];
       FormData.SuperConcepts.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});


    }


    updateSuperConcept(seq, SuperConcept){

       let FormData = {...this.state.FormData};
       FormData.SuperConcepts = [...(FormData.SuperConcepts || [])];
       FormData.SuperConcepts[seq-1] = SuperConcept;

       this.setState({"FormData": FormData});

    }


    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;

        let target = null;
        if (event.target.tagName == "a"){
            target = event.target;
        } else{
            if ("parentElement" in event.target){
                if (event.target.parentElement.tagName == "a"){
                    target = event.target.parentElement;
                }
            }
        }

        if (target){
            if ("href" in target){
                idNode = target.href.baseVal;
                StateChange.vizNodeId = idNode;
            }
        }
        

        if (!idNode){
            return;
        }
        
        let partsVizNodeId = idNode.split('_');
        switch(partsVizNodeId[0]){
            case 'concept':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/concept/${partsVizNodeId[1]}`);
                }
                break;
        }

        this.setState(StateChange);

        event.preventDefault();

    };


    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);


    };



    visualise(){
    
        if (!this.state.Concept){
            return null;
        }


        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.state.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }

/*
        switch (this.state.mode){
            case 'new':
                if (!this.state.isLoadedConceptModel){
                    return <div/>
                }        
                break;
            case 'edit':


            default:

                if (this.state.isFailed){
                    return <PD.ErrorBox>ERROR - Failed to Load</PD.ErrorBox>
                }

                if (!this.state.isLoadedConcept){
                    return <div/>
                }
        }
*/

/*
        switch (this.state.mode){
            case 'remove':
                if (this.state.isUpdated){
                    this.props.navigation(this.FallBackNavigation);
                }
                break;
        }
*/

        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Concept</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>
                                        ERROR - Failed to Update
                                        {this.state.errorMessage && <><br/>{this.state.errorMessage}</>}
                                    </PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor name="notes" label='Notes' value={this.state.FormData.notes} onChange={this.handleChange}/>
                                    <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.ConceptStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    {this.FormSuperConcepts()}

                                    <Revision ref={this.refRevision}  idAbout={this.state.idConcept}/>
                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Concept</PD.Heading>

                        {this.state.renderState == "error" &&
                            <PD.ErrorBox>
                                ERROR - Failed to Update
                                {this.state.errorMessage && <><br/>{this.state.errorMessage}</>}
                            </PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewConcept Concept={this.state.Concept}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        let countSuperConcepts = 0;
                        if (this.state.Concept.SuperConcepts){
                            countSuperConcepts = this.state.Concept.SuperConcepts.length;
                        }


                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Concept:{this.state.Concept.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewConcept Concept={this.state.Concept}/>

                                <br/>

                                <PD.Tabs>


                                    <div label='Visualise'>
                                        {this.visualise()}
                                    </div>


                                    <div label='Concept Model'>
                                        <ViewConceptModel ConceptModel={this.state.ConceptModel} />
                                    </div>

                                    <div label={`Super Concepts(${countSuperConcepts})`}>

                                        <ListConcepts filters={{"idSubConcept":this.state.idConcept}} columns={{conceptmodel:true, owner:true}} />

                                    </div>


                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Concept} />
                                    </div>
                                    
                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/concepts"
                                            id={this.state.idConcept}
                                        />
                                    </div>


                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };


    FormSuperConcepts(){

        let seqNext = 1;
        if (this.state.FormData.SuperConcepts){
            seqNext = this.state.FormData.SuperConcepts.length + 1;
        }
        return (
            <fieldset>
                <legend>Super Concepts</legend>
                <PD.Table type="list">
                    {this.state.FormData.SuperConcepts &&
                        this.state.FormData.SuperConcepts.map(
                            (SuperConcept, posSuperConcept) => 
                            {
                                let seq = posSuperConcept+1;
                                return(
                                    this.FormSuperConcept('edit', seq, SuperConcept)
                                )
                            }
                        )
                    }
                    {this.FormSuperConcept('new', seqNext)}
                </PD.Table>
            </fieldset>
        );

    }

    FormSuperConcept(mode, seq, SuperConcept = {}){
        return(
            <SuperConceptRow 
                key={seq.toString()}
                mode={mode}
                onAdd={this.addSuperConcept}
                onRemove={this.removeSuperConcept}
                onUpdate={this.updateSuperConcept}
                SuperConcept={SuperConcept}
                seq={seq}
                Concept={this.state.Concept}
            />
        )
    }


};

// Wrap and export
export default function Concept_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Concept {...props} navigation={navigation} location={location} params={params} />;
  }
